if (typeof UseSwStat == 'undefined' || typeof UseSwStat == 'null') {
    var UseSwStat = false;
}

if (typeof UseTagManager == 'undefined' || typeof UseTagManager == 'null') {
    UseTagManager = false;
}


function toggleBasket() {


    if ($(".RightBasket").hasClass("active")) {
        $(".RightBasket").removeClass("active");
        $("body").removeClass("BasketDropped");
    }
    else {
        $(".RightBasket").addClass("active");
        $("body").addClass("BasketDropped");
        setContentHeight();
    }
}



function TagAutoComplate() {


    if ($("#SmallLangCode").val() != 'en') {

        $(".customAutoComplete").autocomplete({

            source: "/" + $("#SmallLangCode").val() + "/p/Cat/CompleteNames",
            minLength: 2,
            maxResults: 10,
            select: function (event, ui) {

                if (ui.item.FilterType == "Product") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/" + ui.item.HexValue;
                }



                if (ui.item.FilterType == "BlogPost") {
                    window.location.href = "/blog" + ui.item.SubValue;
                }

            }
                ,
            create: function () {


                $(this).data('ui-autocomplete')._renderItem = function (ul, item) {


                    if (item.FilterType == "Product") {
                        $li = $('<li class="PrItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='PrHeader'>" + item.SubValue + "</span>");
                        $li.append("<span>" + item.MainValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    if (item.FilterType == "BlogPost") {

                        $li = $('<li class="BlogItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='BlogHeader'>" + item.MainValue + "</span>");
                        $li.append("<span>" + item.HexValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    else
                        if (item.FilterType == "Color") {
                            $li = $('<li class="ColorItem">').append('<span class="HexItem" style="background-color:#' + item.HexValue + '" alt="" />');

                            $li.append("<div class='ColorHeader'>" + item.MainValue + "</span><span>Renklerde Arayın</span>");
                            $li.append("");
                            $li.append("<span class='Info'></span>");

                            $li.appendTo(ul);

                            return $li;

                        }
                        else {
                            return $('<li>')
                        .append(item.MainValue)
                        .appendTo(ul);
                        }

                };
            },
            focus: function (event, ui) {

                event.preventDefault();
                $(".SearchModal form input:first").val(ui.item.MainValue);

            }

        });
    }
}

function GetHelp(x) {

    $('.help_div').hide();
    $('.help_' + x).show();


    $('.help_' + x).children("div.subhelp:first").show();


}

function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0 ; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function changeSiteTheme(layout) {


    $.ajax({
        type: 'get',
        url: '/Home/ChangeTheme',
        data: 'Url=' + window.location.pathname + "&th=" + layout + "&hash=" + window.location.hash,
        success: function (dt) {

            window.parent.location.href = dt;
        }
    });

}

function ShowLangAreaForChange() {


    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {

        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }

            } else {

                $(".LangSelectionArea").hide();
            }

        }
    });

}

function ShowCurrencyForChange() {


    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}







function SetWindowSize() {

    var mobileValues = $("html").attr("class").trim();



    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/User/SetUserWindowSize?u.Width=" + $(window).width() + "&u.Height=" + $(window).height() + "&u.mobileInfo=" + mobileValues,
        cache: false,
        success: function (cdt) {

        }
    });

    if ($(window).width < 980) {

        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");

    }

}

$.fn.exists = function () {
    return this.length !== 0;
}

var lastpos = -1;
var showTopLink = 20;
var width = 0;
var UserValue;

$('#NewsletterPopup').on('hidden.bs.modal', function () {
    var expireDate = new Date();
    var minutes = 30;
    expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);

    $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
    $(".NewsLetterResult").hide();
    $(".NewsletterFormHead").show();
})

function LoginIcon() {
    $(".LoginIcon").on("click", function () {
        $("#RegisterLoginModal").modal();
    });
}

function AddToBasket() {
    $(".ProductList .Prd .AddToCart").on("click", function (e) {


        var SizeID = $(this).attr("data-sizeid");
        var SizeDropID = "1";
        var ColorID = $(this).attr("data-colorid");
        var ProductID = $(this).attr("data-productid");

        var Amount = 1;
        var LangID = $("#LangID").val();
        var UrunYok = $('#UrunYok').val();


        SizeDropID = "1";

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {


            var SizeDrop = "";

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            if (SizeDropID == "yok") {
                SizeDrop = "";
            }
            else {
                SizeDrop = "&SizeDropID=" + SizeDropID;

            }

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID + SizeDrop,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                if ($(window).width() < 992) {
                                    $(".MobileUserMenu").append("<a href='javascript:;'>" + $(dt).find("#Hesabim").val() + "</a><div class='itemsWrapper'></div>");

                                    $(".MobileUserMenu > .itemsWrapper").html($(dt).find(".AccountMenuInner").html());
                                    ToggleLeftMenuItem();
                                    SearchButton();

                                }


                                $(".BasketContainer").html(dt);

                                BasketLink();

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");
                                setContentHeight();
                                $(".AjaxLoaderDiv").hide();

                            }
                        });


                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);

                        }

                        if (UseTagManager) {

                            SendCartAddEvent('');
                        }


                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });




        }
        else {

            if (SizeID == undefined || SizeID == "") {


                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");

                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });
}

function MenuMouseOver() {

    $(".Hovered").removeClass("Hovered");

    $("#MainNewMenu  li > .itemsWrapper > .ListWrapper > ul > li:first-child > .itemsWrapper").addClass("Hovered");


    $(".ScrolledMenu.Users .TopBarLinks span,.userNavMenu").on("mouseover", function () {

        if (!$("body").hasClass("BackDropped")) {
            $("body").stop().addClass("BackDropped");
            $(this).closest(".UserAndBasketContainer").find("section").addClass("showSection");

        }
    });



    $(".ScrolledMenu.Users .TopBarLinks span,.userNavMenu").on("mouseout", function () {
        if ($("body").hasClass("BackDropped")) {
            $("body").stop().removeClass("BackDropped");
            $(this).closest(".UserAndBasketContainer").find("section").removeClass("showSection");
        }
    });


    $("#MainMenu li,#MainNewMenu li").on("mouseover", function () {
        if (!$("body").hasClass("BackDropped") && $(this).find(".itemsWrapper").size() > 0) {
            $("body").stop().addClass("BackDropped");
        }
    });



    $("#MainMenu li,#MainNewMenu li").on("mouseout", function () {
        if ($("body").hasClass("BackDropped")) {
            $("body").stop().removeClass("BackDropped");
        }
    });



    $("#MainNewMenu > li").on("mouseout", function () {

        var times = setTimeout(function () {

            $("#MainNewMenu > li > .itemsWrapper > .ListWrapper > ul").trigger("closedMenu");

        }, 500);

        $(this).data('times', times);

    });

    $("#MainNewMenu > li").on("mouseover", function () {
        clearTimeout($(this).data('times'));
    });

    $("#MainNewMenu > li > .itemsWrapper > .ListWrapper > ul").on("closedMenu", function (e) {
        $(".Hovered").removeClass("Hovered");
        $("#MainNewMenu  li > .itemsWrapper > .ListWrapper > ul > li.FirstItem > .itemsWrapper").addClass("Hovered");
    });



    $('#MainNewMenu > li > .itemsWrapper > .ListWrapper > ul > li')
        .on('mouseover', function (e) {

            var that = $(this);

            var timer = setTimeout(function () {

                $(".Hovered:visible").removeClass("Hovered");

                that.find(".itemsWrapper").addClass("Hovered");

            }, 500);

            that.find(".itemsWrapper").data('timer', timer);
        });

    $('#MainNewMenu > li > .itemsWrapper > .ListWrapper > ul > li')
        .on('mouseout', function (e) {

            clearTimeout($(this).find(".itemsWrapper").data('timer'));
        });



}

function UserMouseOver() {

    $(document).on("mouseover", ".RightAccount", function () {
        $("body").addClass("BasketDropped");
        $(this).addClass("open");
    });

    $(document).on("mouseout", ".RightAccount", function () {
        $("body").removeClass("BasketDropped");
        $(this).removeClass("open");
    });

}

function BasketMouseOver() {

    $(document).on("mouseover", ".RightBasket", function () {
        $("body").addClass("BasketDropped");
        setContentHeight();
        $(this).addClass("active");
    });

    $(document).on("mouseout", ".RightBasket", function () {
        $("body").removeClass("BasketDropped");
        $(this).removeClass("active");
    });

}

function RegisterLoginModal() {



    $(".card-define-button").live("click", function () {

        $("div.RegisterRow").hide();
        $("div.LoginRow").hide();
        $("div.OxxoControl").show();
        $("span.ControlResult").hide();
        $("div#AlertResult").hide();

        if ($(window).width() < 768) {
            $('#RegisterLoginModal').animate({ scrollTop: 0 }, 'slow');
        }
    });

    $(".create-user-button").live("click", function () {

        if ($(".leftColumn > h2 > span.selected").html() == "Giriş Yap") {

            $("div.RegisterRow").hide();
            $("div.LoginRow").show();
            $("div.OxxoControl").hide();
            $("span.ControlResult").hide();
        }

        else if ($(".leftColumn > h2 > span.selected").html() == "Yeni Üyelik") {

            $("div.RegisterRow").show();
            $("div.LoginRow").hide();
            $("div.OxxoControl").hide();
            $("span.ControlResult").hide();
        }

        $(".create-user-button > span").each(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
            }
            else {
                $(this).addClass("selected");
            }
        });

        $(".leftColumn > h2 > span").each(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
            }
            else {
                $(this).addClass("selected");
            }
        });

        if ($(window).width() < 768) {
            $('#RegisterLoginModal').animate({ scrollTop: 0 }, 'slow');
        }




    });


    $(".modal-close-button").live("click", function () {
        $("#RegisterLoginModal").modal("toggle");
    });


    $('#RegisterLoginModal').on('show.bs.modal', function () {
        $(".UyeKayitCol > div").removeClass("selected");
        $(".UyeKayitCol .LoginRow").addClass("selected");
        $(".create-user-button span").removeClass("selected");
        $(".create-user-button .createUser").addClass("selected");
        $("header").addClass("LoginModal");
        $("#AlertResult").hide();
    });




    $('#RegisterLoginModal').on('hidden.bs.modal', function () {

        $("header").removeClass("LoginModal");
        $("#AlertResult").hide();

    });

}

function MenuBannerSettings() {
    $DefaultImage = "";

    $(".ListWrapper > ul > li").hover(function () {
        $BannerArea = $(this).parent().parent().parent().find(".MenuBanner > img");
        $DefaultImage = $BannerArea.attr("src");

        if ($(this).data("img") != "" && $(this).data("img") != null) {
            $BannerArea.attr("src", $(this).data("img"));

        }
    }, function () {
        $BannerArea.attr("src", $DefaultImage);
    });

}

function Isfollow() {

    var ProductID = $("#ProductID").val();
    $That = $(".PrLike");

    if (ProductID != undefined) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollow",
            data: 'ProductID=' + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.IsFollow == true) {
                    $That.removeClass("add");
                    $That.addClass("active");
                } else {
                    $That.addClass("add");
                    $That.removeClass("active");
                }



            }
        });
    }

}

function AutoDropSelection() {
    $(".DropItems a:first-child").trigger("click");
}

function GetOxxoCardPrice() {

    var Amount = $("#ForMemberCardAmount").val();
    var OldAmount = $("#ForMemberCardOldAmount").val();
    var MemberCardGroupID = $("#MemberCardGroupID").val();
    var ForMemberCardCurrencyCode = $("#ForMemberCardCurrencyCode").val();

    if (Amount != undefined && OldAmount != undefined && MemberCardGroupID != undefined && ForMemberCardCurrencyCode != undefined && MemberCardGroupID != -1) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetMemberCardPrice",
            data: 'Amount=' + Amount + "&AmountOld=" + OldAmount + "&MemberCardGroupID=" + MemberCardGroupID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.TotalAmount != "0" && dt.TotalAmount != 0) {
                    $(".RPrice").html(dt.TotalAmount + " " + ForMemberCardCurrencyCode);
                    $(".OxxoCardPrice").css("display", "inline-block");
                }

            }
        });
    }

}

function MobileMenuSetting() {

    $("#MainMenu > ul > li,#MainNewMenu > ul > li").each(function () {
        if ($(this).find(".itemsWrapper").length > 0 && !$(this).hasClass("TabletMenu")) {
            $(this).addClass("plus-icon");
        }
    });



}

function AddToFavorite() {


    $(".passiveFavorite").live("click", function () {
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        $That = $(this);
        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");
                    }


                }
            });
        }
    });


}

function removeFavorite() {
    $(".activeFavorite").live("click", function () {
        var ProductID = $("#ProductID").val();
        $That = $(this);
        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'id=' + ProductID + "&IsDetail=true",
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");
                    }


                }
            });
        }
    });
}

function ModalOpenRM() {
    $(".AccountOpen #CardLink").live("click", function () {

        $("#RegisterLoginModal").modal("toggle");

    });
}

function ChangePlaceholderSearch() {

    if ($(window).width() <= 500) {

        $('.fullSearch input[type="search"]').attr("placeholder", "Aradığınız ürün burada.");
    } else {

        $('.fullSearch input[type="search"]').attr("placeholder", "Aramak istediğiniz kelimeyi giriniz.");
    }
}

$(window).resize(ChangePlaceholderSearch).trigger('resize');

function ToggleFooterMenu() {
    $(".FooterMenuContainerTR .bottomMenu,.FooterMenuContainerEN .bottomMenu").live("click", function () {

        $(this).find("ul").slideToggle();

    });


}

function ToggleLeftMenuItem() {

    $("#MainMenu > li > a,#MainNewMenu > li > a").hammer().bind("tap", function (e) {

        if ($(window).width() < 992 && !$(this).parent().hasClass("TabletMenu") && !$(this).parent().hasClass("menuDownArrowSub") && !$(this).parent().find(".itemsWrapper").length <= 0) {
            $(this).parent().find("> .itemsWrapper").slideToggle();
            $(this).parent().toggleClass("opened");
        }
    });

    $("#MainNewMenu > li > .itemsWrapper").find(".ListWrapper > ul > li > a").hammer().bind("tap", function (e) {

        if ($(window).width() < 992 && !$(this).parent().hasClass("TabletMenu")) {
            $(this).parent().find("> .itemsWrapper").slideToggle();

            if ($(this).parent().find(".itemsWrapper").length > 0) {

                $(this).parent().toggleClass("openedSub");
            }
            else {
                $(this).parent().toggleClass("openedSubSingle");
            }

        }
    });
}

function UserMenuToggle() {
    if ($(window).width() > 991) {
        $(".RightAccount").live("click", function () {
            $(this).toggleClass("open");
            $('body').toggleClass("BasketDropped");
        });
    }
}

function menuAddArrow() {
    $("#MainMenu li,#MainNewMenu li").each(function () {
        if ($(this).find(".itemsWrapper").size() <= 0) {
            $(this).find("a img").hide();

        }
    });
}

function MobileMenuHrefSet() {
    if ($(window).width() < 992) {
        $("#MainMenu > li > a,#MainNewMenu > li > a").each(function () {
            if ($(this).parent().find(".itemsWrapper").length > 0) {
                $(this).attr("data-href", $(this).attr("href"));
                $(this).attr("href", "javascript:;");
            }

        });
    } else {
        $("#MainMenu > li > a,#MainNewMenu > li > a").each(function () {
            if ($(this).parent().find(".itemsWrapper").length > 0) {
                $(this).attr("href", $(this).attr("data-href"));
                $(this).attr("data-href", "javascript:;");
            }

        });
    }

    if ($(window).width() < 992) {
        $("#MainNewMenu > li > .itemsWrapper > .ListWrapper > ul > li > a").each(function () {
            if ($(this).parent().find(".itemsWrapper").length > 0) {
                $(this).attr("data-href", $(this).attr("href"));
                $(this).attr("href", "javascript:;");
            }

        });
    } else {
        $("#MainNewMenu > li > .itemsWrapper > .ListWrapper > ul > li > a").each(function () {
            if ($(this).parent().find(".itemsWrapper").length > 0) {
                $(this).attr("href", $(this).attr("data-href"));
                $(this).attr("data-href", "javascript:;");
            }

        });
    }
}

function MenuMobileClick() {

    MobileMenuHrefSet();
    $(window).resize(function () {
        MobileMenuHrefSet();
    });


}

function FooterTextSplit() {

    $('.FooterText > p').textSummary();
}

function AddMenuDownIcon() {

    $("#MainNewMenu > li > .itemsWrapper > .ListWrapper > ul > li").each(function () {

        if ($(this).hasClass("SetOpenedMenuSub")) {
            $(this).toggleClass("openedSub");
            $(this).find(".itemsWrapper").css("display", "block");
        }

    });

    $("#MainMenu > li,#MainNewMenu > li").each(function () {

        if ($(this).find(".itemsWrapper").length > 0) {
            $(this).addClass("menuDownArrow");
            var mainhref = $(this).find(" > a").attr("data-href");
            $(this).find(" > .itemsWrapper > .ListWrapper > ul").prepend("<li class='tumunugor hidden-md hidden-lg'><a href='" + mainhref + "'>Tümünü Gör</a></li>");
        }
        if ($(this).hasClass("SetOpenedMenu")) {
            $(this).addClass("opened");
            $(this).find("> .itemsWrapper").css("display", "block");
        }

    });

    $("#MainNewMenu > li").each(function () {

        var that = $(this).find("> .itemsWrapper > .ListWrapper > ul > li");
        if (that.find(".itemsWrapper").length > 0) {
            that.addClass("menuDownArrowSub");
        }


    });

}


function CloseDetection() {
    $(window).on('mouseover', (function () {
        window.onbeforeunload = null;
    }));
    $(window).on('mouseout', (function () {
        window.onbeforeunload = ConfirmLeave;
    }));
    function ConfirmLeave() {
        alert("hey");
    }
    var prevKey = "";
    $(document).keydown(function (e) {
        if (e.key == "F5") {
            window.onbeforeunload = ConfirmLeave;
        }
        else if (e.key.toUpperCase() == "W" && prevKey == "CONTROL") {
            window.onbeforeunload = ConfirmLeave;
        }
        else if (e.key.toUpperCase() == "R" && prevKey == "CONTROL") {
            window.onbeforeunload = ConfirmLeave;
        }
        else if (e.key.toUpperCase() == "F4" && (prevKey == "ALT" || prevKey == "CONTROL")) {
            window.onbeforeunload = ConfirmLeave;
        }
        prevKey = e.key.toUpperCase();
    });
}

function BasketLink() {

    $(document).on("click", ".SepetButton > a", function () {
        if ($(window).width() > 991) {
            var checkOutUrl = $(".SepetButton > input[type=hidden]").val();
            window.location.href = checkOutUrl;
        }
    });


}


function closeForgottenPass() {
    $("#forgottenpassModal").modal("hide");
}

function MyOrderDetailForMemberless() {

    $(".TrackCodeLink").on("click", function () {
        $.ajax({
            type: "GET",
            url: $(this).data("href"),
            cache: false,
            success: function (data) {
                if (data != null && data != undefined && data != "") {
                    $("#UserOrderModal .modal-content").html(data);
                }
            }
        });
    });
}


function SearchButton() {
    $(document).on("click", '.RightSearch', function () {
        $("#Mainmenu ul li div.itemsWrapper,#MainNewMenu ul li div.itemsWrapper").hide();
        $("#MainMenu,#MainNewMenu").toggleClass("open");
        if ($("#MainMenu,#MainNewMenu").hasClass("open") == true) {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            $("body").addClass("LeftMenuOpen");
        }
        else {
            $("body").removeClass("LeftMenuOpen");

        }
    });
}

function KvkkModal() {
    $(document).on("click", ".KVKKTrigger", function () {
        $("#KVKKModal").modal();
    });
}

function PanelClosing() {
    var expireDate = new Date();
    var minutes = 30;
    expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);

    $(document).on("click", ".leftPanelClose", function () {
        $(".FiltersContainer").toggleClass("hideLeftPanel");
        $("body").toggleClass("leftPanelClosed")
        CheckFooterWidth();
        var leftState = ($("body").hasClass("leftPanelClosed")) ? false : true;
        setContentHeight();
        PanelStateChanged(leftState);
        $.cookie('leftPanel', leftState, { expires: expireDate });

    });

    $(document).on("click", ".rightPanelClose", function () {
        $(".BasketContainer").toggleClass("hideRightPanel");
        $("body").toggleClass("rightPanelClosed")

        var rightState = ($("body").hasClass("rightPanelClosed")) ? false : true;
        CheckFooterWidth();
        setContentHeight();
        PanelStateChanged(rightState);
        $.cookie('rightPanel', rightState, { expires: expireDate });
        NavigationButtons();
    });
}


function NavigationButtons(){
    var basketContainerWidth = $(".BasketContainer").width();
    var rightCloseButton = 25;
    //console.log(basketContainerWidth + "-" + rightCloseButton);
    if ($("body").hasClass("rightPanelClosed")) {
        $(".rightPanelClose").css("right", "0px");
    } else {
        $(".rightPanelClose").css("right", (basketContainerWidth - rightCloseButton) + "px");
    }
    
}

function FixedLeftBar() {
    $(window).scroll(function () {
        if ($("body").hasClass("Scrolled")) {
            $("#SubCatNavs").addClass("FixedLeftBar");
        } else {
            $("#SubCatNavs").removeClass("FixedLeftBar");
        }
    });
}

function CheckPanelState() {

    //console.log($.cookie('leftPanel'));
    //console.log($.cookie('rightPanel'));
    if ($.cookie('leftPanel') && $.cookie('leftPanel') == "false") {

        $(".FiltersContainer").addClass("hideLeftPanel");
        $("body").addClass("leftPanelClosed")

    } else {
        $(".FiltersContainer").removeClass("hideLeftPanel");
        $("body").removeClass("leftPanelClosed")
    }
    
    if ($.cookie('rightPanel') && $.cookie('rightPanel') == "false") {

        $(".BasketContainer").addClass("hideRightPanel");
        $("body").addClass("rightPanelClosed")
        NavigationButtons();

    } else {
        $(".BasketContainer").removeClass("hideRightPanel");
        $("body").removeClass("rightPanelClosed")
        NavigationButtons();

    }

}

function CheckFooterWidth() {
    $(".footer").css({
        "z-index": "99",
        "left": "initial"
    });
    $(".footer").width($(".ContentContainer").width());

}



function GenericWindowResize() {
    
    $(window).resize(function () {
        CheckFooterWidth();
        setContentHeight();
        NavigationButtons();
    });
}

function setContentHeight() {
    var basketContainerHeight = $(".BasketContainer").outerHeight(true);
    var basketHeadHeight = $(".miniSepetClose").outerHeight(true);
    var basketFooterHeight = $(".RightBasket .Bottom").outerHeight(true);
    var basketContentPadding = parseFloat($(".BasketContent").css("padding-top")) + parseFloat($(".BasketContent").css("padding-bottom"));
    //console.log(basketContainerHeight + "--" + basketHeadHeight + "--" + basketFooterHeight + "--" + basketContentPadding + "--" + (basketContainerHeight - (basketHeadHeight + basketFooterHeight)));

    $(".BasketContent").height(basketContainerHeight - (basketHeadHeight + basketFooterHeight + basketContentPadding));
}

function PanelStateChanged(state) {
 
    var sideChanged = $.Event('sidepanelchanged');
    sideChanged.state = state;
    $(window).trigger(sideChanged);

}


$(document).ready(function () {
    CheckPanelState();
    RegisterLoginModal();
    ModalOpenRM();
    AddToBasket();
    ChangePlaceholderSearch();
    MenuMouseOver();
    UserMenuToggle();
    menuAddArrow();
    Isfollow();
    MenuMobileClick();
    PanelClosing();
 
    KvkkModal();
    NavigationButtons();

    CheckFooterWidth();
    GenericWindowResize();

    MyOrderDetailForMemberless();
    PanelStateChanged(true);
    AddMenuDownIcon();
    if ($(window).width() < 992) {
        ToggleFooterMenu();
        FooterTextSplit();
    }




    $("#OxxoControlButton").live("click", function () {
        $.ajax({

            type: "POST",
            url: "/tr/p/User/OxxoCardControl?NameSurname=" + $("#NameSurname").val() + "&PhoneNumber=" + $("#Phone").val() + "&Email=" + $("#Email").val(),
            cache: false,
            success: function (data) {
                if (data > 0) {

                    $("div.OxxoCardPlace").hide();
                    $("span.ControlResult").css("display", "block");
                    $("span.ControlResult").html('<br/><div class="alert alert-danger">OxxoCard sahibisiniz. Üye girişi yaparak avantajlardan yararlanabilirsiniz</div>');
                    $("div.LoginRow").css("display", "block");
                }
                else if (data == -1) {
                    $("span.ControlResult").show().html('<br/><div class="alert alert-danger">Lütfen tüm alanları eksiksiz doldurunuz.</div>');

                }
                else if (data.StatusCode == -2) {

                    $("div.OxxoCardPlace").hide();
                    $("div.RegisterRow").show();
                    $("form.UyeOlModal #LoginNameSurname").val(data.Name);
                    $("form.UyeOlModal #LoginEposta").val(data.Email);
                    $("form.UyeOlModal #UserGsm").val(data.Mobile);
                    $("form.UyeOlModal #LoginPassword").val("");

                    $("span.ControlResult").show().html('<div class="alert alert-danger">OxxoCard tanımlamak için önce üye olunmalıdır.</div>');
                }
                else {

                    $("div.OxxoCardPlace").hide();
                    $("span.ControlResult").show().html('<br/><br/><br/><div class="alert alert-danger"> <strong>OxxoCard</strong> bilginiz bulunmamaktadır, OxxoCard alarak fırsatlardan yararlanabilirsiniz</div>');

                    setTimeout(function () {
                        window.location.href = "/Home/Index";
                    }, 3000);

                }
            }
        });

        return false;
    });


    $('.FooterTextShowMore').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowLess').show();
        $('.FooterTextSecondPart').show();
    });

    if (document.URL.indexOf("/outlet") != -1 && $("#MainMenu .outlet").length > 0) {
        $("#MainMenu .outlet").show();
        $("#MainMenu .outlet").prev().hide();
    }

    $('.FooterTextShowLess').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowMore').show();
        $('.FooterTextSecondPart').hide();

    });




    MobileMenuSetting();
    MenuBannerSettings()
    AddToFavorite();

    if ($(window).width < 980) {
        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");
    }

    $('.top_link').hide();
    width = $(window).width();




    var ThemePath = "/Images/BlackTheme/";

    if ($(".LogoContainer img").length > 0) {
        ThemePath = $(".LogoContainer img:first").attr("src").replace("Logo.png", "");
    }





    $('.carousel').carousel();



    $("body .backdrop").on("click", function (e) {


        $("body").removeClass("LeftMenuOpen BackDropped BasketDropped");
        $("#MainMenu").removeClass("open");

        $(".RightBasket, .RightAccount").removeClass("active");

    });




    $("body #PrdBlackBg").on("click", function (e) {

        $("#PrdBlackBg").hide();
        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".DropItems.PleaseSelect").removeClass("PleaseSelect");
        $(".AddToBasketOuther.PleaseSelect").removeClass("PleaseSelect");
        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }
    });

    $('.top_link').click(function () {

        $('html, body').animate({ scrollTop: 0 }, 'slow');

    });

    $(window).scroll(function () {


        if ($('.top_link').length > 0) {

            if ($(window).scrollTop() > showTopLink) {
                $('.top_link').fadeIn('slow');
            } else {
                $('.top_link').fadeOut('slow');
            }

        }


        if ($(window).scrollTop() > showTopLink) {

            $("body").not(".ProductDetails").addClass("Scrolled");

        } else {
            $("body").removeClass("Scrolled");
        }


    });

    window.scrollTo(window.scrollX, window.scrollY + 1);

    FixedLeftBar();


    var rtime;
    var timeout = false;
    var delta = 500;

    $(window).resize(function () {

        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }
    });

    function resizeend() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
        } else {
            timeout = false;
            if ($(".dortyuzdort").length <= 0) {
                SetWindowSize();
            }
        }
    }

    $('.bottomMenu p').click(function () {

        $(this).parent().toggleClass("open");

    });

    $("#CurrencySelectionDr").on("click", ".CurrencyItem", function () {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]")
        var CurrencyID = $(this).attr("data-id");

        $(".CurrenctCur img").attr("src", $(this).find("img").attr("src"));
        $(".CurrenctCur .TL").html($(this).find(".TL").html());
        $(".CurrenctCur .CurrCode").html($(this).find(".CurrCode").html());

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: 'Url=' + window.location.pathname + "&currencyID=" + CurrencyID + "&hash=" + window.location.hash,
            success: function (dt) {

                window.location.reload(true);

            }
        });


    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });


    $(".btn-back").live("click", function () {

        $(this).closest("form").slideUp();

    });

    TagAutoComplate();


    $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal');
    });

    $('.help_Uyelik, .help_Uyelik .subhelp:first').show();
    $('#helpMenu ul li:first a').addClass("secili");


    $('#helpMenu ul li a').on('click', function (e, index) {

        $('#helpMenu ul li a').removeClass('secili');
        $(this).addClass('secili');
        GetHelp($(this).attr('href').replace(/#/ig, ""));
    });

    $('.subhelptitle').on('click', function (e, index) {


        var c = $(this).attr('id').replace(/title/, "");
        $('.subhelp:visible').slideUp('fast');
        $('.' + c).slideDown('fast');

    });

    $("#HelpNavs div ul").first().show();
    $("#HelpContents ul li").hide();
    $("#HelpContents div").eq($("#HelpNavs div .HelpNavTitles").first().parent().index()).find("ul li:first").show();


    $('#HelpNavs li').click(function () {

        $("#HelpContents ul li").hide();

        $("#HelpContents div").eq($(this).closest("div").index()).find("ul li").eq($(this).index()).show();

    });

    $('#HelpNavs > div').click(function () {


        $("#HelpNavs div > ul").hide();
        $(this).find("ul").show("normal");


    });

    $('.HelpNavTitles').click(function () {

        $("#HelpContents ul li").hide();
        $("#HelpContents div").eq($(this).parent().index()).find("ul li:first").show();

    });


    if ($("#UserAndBasket").length > 0) {
        if ($(".dortyuzdort").length <= 0) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                data: "",
                async: true,
                cache: false,
                contentType: "application/json; charset=utf-8",
                dataType: 'text',
                success: function (dt) {




                    if ($(window).width() < 992) {
                        $(".MobileUserMenu").append("<a href='javascript:;'>" + $(dt).find("#Hesabim").val() + "</a><div class='itemsWrapper'></div>");

                        $(".MobileUserMenu > .itemsWrapper").html($(dt).find(".AccountMenuInner").html());
                        ToggleLeftMenuItem();
                        SearchButton();

                    }

                    $(".BasketContainer").html(dt);

                    BasketLink();

                    if ($("#LangRedirectNeed").length > 0) {

                    }

                    if ($("#LangSelectionNeed").length > 0) {
                        ShowLangAreaForChange();
                    }

                    if ($("#CheckCampaign").length > 0) {

                        $.ajax({
                            type: "GET",
                            url: "/" + $("#SmallLangCode").val() + "/p/User/CheckForCampaigns",
                            cache: false,
                            success: function (cdt) {

                                if (cdt == "ShowUtm2Banner" && document.URL.indexOf("utm_campaign") < 0) {

                                    document.location = "/" + $("#SmallLangCode").val() + "/?utm_campaign=colorselect2";
                                }
                            }
                        });

                    }
                    if ($(window).width() > 991) {
                        setContentHeight();
                        //BasketMouseOver();
                        //UserMouseOver();
                    } else {

                        $(".RightBasket .SepetButton").on("click", function () {
                            if ($(window).width() < 992) {
                                $("body").toggleClass("BasketDropped");
                                setContentHeight();
                                $(this).closest(".RightBasket").toggleClass("active");
                            }

                        });


                    }


                    if ($("#WindowSizeNotSetted").length > 0) {

                        SetWindowSize();
                    }

                    if (UseTagManager) {

                        AddGeneralInfoTagManager('', dtIsLogged, dtUserID);

                        AddProductView('');
                        var promotions = GetPromotionsVariable('');
                        AddImpression('', promotions);

                        SendGaDataLayerVirtual();
                    }

                    var UserID = $("#UserID").val();

                    if (UserID != undefined && UserID > 0) {
                        Isfollow();
                    }
                    GetOxxoCardPrice();
                }
            });
        }
    }
    if ($(".dortyuzdort").length <= 0) {
        SetWindowSize();
    }


    $(".BasketContainer .RemoveIcon").live("click", function () {

        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        $(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {

                if (dt.Sonuc == true) {

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveCoupon',
                        contentType: "application/json; charset=utf-8",
                        dataType: 'json',
                        success: function (dt) {
                            //console.log(dt);
                        }
                    });

                    $(gizlenecekSecim).hide("slow");


                    if ($("span#SepetToplamTutar").length > 0) {

                        if ($("span:last", "span#SepetToplamTutar").exists()) {
                            $("span:last", "span#SepetToplamTutar").text(dt.Deger1.toFixed(2).toString().replace(".", ",") + " " + $("#CurrencyCode").val());

                        }

                        if ($(".SepetToplamTutar:first span.CartTotalAmount span.PriceRound").length > 0) {
                            $deger = dt.Deger1.toFixed(2).toString();
                            var CartTotalAmount = new Array();
                            CartTotalAmount = $deger.split('.');
                            $(".SepetToplamTutar span.CartTotalAmount").html(CartTotalAmount[0] + "<span class=\"PriceRound\">." + parseInt(CartTotalAmount[1]) + "</span>");


                        }

                        else {
                            $(".SepetToplamTutar:first span:last").html(dt.Deger1.toFixed(2).replace(".", ",") + " " + $("#CurrencyCode").val());
                        }



                        if ($("#FirstCountryID").length > 0) {
                            $.fn.AddOrRemoveCargo();

                        }
                    }


                    $userCartIcon = $(".UserCartIcon");

                    if ($userCartIcon.length > 0) {

                        $BasketIconCountItem = $(".UserCartIcon").find(".IconCount");
                        var IconCount = Number($BasketIconCountItem.text());
                        IconCount = IconCount - Number($(gizlenecekSecim).attr("data-quantity"));
                        $BasketIconCountItem.text(IconCount);
                        if (IconCount <= 0) {
                            $BasketIconCountItem.addClass("gizli");
                        }


                        if ($("div.SepetRow:visible").length - 1 <= 0) {
                            $userCartIcon.addClass("Blank");
                        }

                    }

                    $(".miniSepetClose .SepetHeading span").html(Number(dt.Deger4));
                    $(".TotalPriceSummary .SepetCount i").html(Number(dt.Deger4));
                    $(".BasketItemCount").html(Number(dt.Deger4));

                    if (dt.Deger4 > 0) {
                        $(".SepetButton .RightButtonText img").attr("src", "/Images/OXB2B/sepet_full.png");
                    } else {
                        $(".SepetButton .RightButtonText img").attr("src", "/Images/OXB2B/sepet.png");
                    }



                    if ($("#MainSepetAdet > span.CartTotalItem").length > 0) {

                        if ($(".BasketText > span").length > 0) {
                            $(".BasketText > span").html(Number(dt.Deger4));
                        }
                        if ($(".CartAmount > span").length > 0) {
                            $(".CartAmount > span").html(Number(dt.Deger4));
                        }
                    }
                    else {
                        if ($(".CartAmount").length > 0) {
                            $(".CartAmount").html(Number(dt.Deger4));
                        }
                    }


                    if (UseTagManager) {

                        SendCartRemoveEvent('', $removedItem);
                    }


                }
                else {

                    alert(dt.IslemSonucAciklama);
                }

            }
        });


    });


    $(".SepetProducts #MinCartClose").live("click", function () {
        location.reload();
    });


    if ($(window).width() < 992) {
        $('.OpenLeftMenu,.CloseLeftMenu, .ToggleMMenuIcon , .MainIcon,.MobileMenuCloseButton').hammer().bind("tap", function () {
            $("#Mainmenu ul li div.itemsWrapper,#MainNewMenu ul li div.itemsWrapper").hide();
            $("#MainMenu,#MainNewMenu").toggleClass("open");
            if ($("#MainMenu,#MainNewMenu").hasClass("open") == true) {
                $('html, body').animate({ scrollTop: 0 }, 'slow');
                $("body").addClass("LeftMenuOpen");
            }
            else {
                $("body").removeClass("LeftMenuOpen");

            }
        });
    }




    $('.SearchModal form input').keyup(function (event) {

        if (event.keyCode == 27) {

            $("body").removeClass("BackDropped");
            $(".SearchModal").hide();

        }
    });

    $('.CloseSearch').click(function (event) {


        $("body").removeClass("BackDropped");
        $(".SearchModal").hide();

    });

    if ($("#FbConfirmMergeModal").length > 0) {

        $("#FbConfirmMergeModal").modal("show");

    }

    if ($("#FbMergeResultModal").length > 0) {

        $("#FbMergeResultModal").modal("show");

    }


    if (window.location.hash == "#Rg" && isMobile(true)) {


        $('html, body').animate({
            scrollTop: $("#LineRg").offset().top + -80
        }, 500);

    }

    if (window.location.hash != undefined && document.URL.indexOf("Yardim") > 0) {

        var curHash = window.location.hash.replace("#", "");

        $("#helpMenu a[href$='" + curHash + "']").trigger("click");
    }


    if (window.location.hash == "#Lg" && isMobile(true)) {


        $('html, body').animate({
            scrollTop: $(".GeneralBreadCrumb:first").offset().top + -50
        }, 500);


    }


    $(".ForgetPass").on("click", function (e) {

        $("#forgottenpassModal").modal('show');

    });

    $(".PopupRegisterBanner").on("click", function (e) {

        $(".RegisterInBanner").click();

    });


    $(".RegisterInBanner").on("click", function (e) {

        $(".LoginRegisterContainer").toggle();
        $(".LoginRegisterContainer").closest(".row-fluid, .row").toggle();
        $(".PopupRegisterBannerContainer").toggleClass("Bordered");

        $("li.tb").removeClass("active");

        if (isMobile(true)) {

            $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

            if ($(".UyeOlModal:visible").length > 0) {

                $("li.tb.reg").addClass("active");

            }
            else {

                $("li.tb.log").addClass("active");

            }

        } else {

            if ($(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").hasClass("pull-right")) {

                $(this).text($(this).attr("data-cur"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

                $("li.tb.reg").addClass("active");


            }
            else {

                $(this).text($(this).attr("data-other"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").addClass("pull-right");

                $("li.tb.log").addClass("active");

            }

        }

        $cur = $(".LoginRegisterContainer");

        $cur.css("opacity", "0.1");

        $cur.animate({
            opacity: 1
        }, 500, function () {
        });


    });


    $(".LogRegTabs li").on("click", function (e) {

        $(".RegisterInBanner").click();

    });


    $("#PayNow").on("click", function (e) {

        document.location.href = $(this).attr("href");

    });
    $(".ModalTab").on("click", function (e) {

        $(".ModalTab").removeClass("active");
        $(this).addClass("active");

        if ($(this).hasClass("Login")) {
            $(".LoginRow").show();
            $(".RegisterRow").hide();
        }
        else {

            $(".LoginRow").hide();
            $(".RegisterRow").show();
        }


    });





    if ($("#WelcomeModal").length > 0) {

        $('#WelcomeModal').modal({
        });

    }

    $(document).on("click", ".OxLogin  .checkbox", function () {
        $(this).find(".customCheck").toggleClass("customCheckTg");
    });

    $("form.UyeOlModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".OxRegister .AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".OxRegister .AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("SignUp");
                    }

                    if (dt.JsonRs == "Redirect") {

                        if (dt.Deger5.length > 0) {

                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }
                    else if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".OxRegister .AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        $form.hide();

                        $(".OxRegister .AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }

                    $(".OxRegister .AlertResult").removeClass("alert-error");
                    $(".OxRegister .AlertResult").hide();

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $(".OxRegister .AlertResult").removeClass("alert-success");
                    $(".OxRegister .AlertResult").addClass("alert-danger");
                    $(".OxRegister .AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.UyeGirisModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".OxLogin .AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".OxLogin .AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {

                        $(".OxLogin .AlertResult").removeClass("alert-danger");
                        $(".OxLogin .AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".OxLogin .AjaxLoader").show();
                        $form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();

                    }


                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".OxLogin .AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    $(".OxLogin .AlertResult").removeClass("alert-danger");

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $(".OxLogin .AlertResult").removeClass("alert-success");
                    $(".OxLogin .AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $(".ProductList .Prd a").live('click', function (e) {

        if (UseTagManager == true) {

            AddGaEvent('', 'Product List', 'Product Click', $(this).closest(".Prd"));

        }



    });


    var ScrollContentID = "LastScrollTop" + $("#PID").val();

    if (isMobile(true) == false) {

        $(".ProductList .Prd").live({
            mouseenter:
               function () {

                   $.cookie(ScrollContentID, null, { expires: -1 });
                   $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });


                   $nextPrd = $(this).next();
                   $prevPrd = $(this).prev();
                   $curItem = $(this);
                   $row = $curItem.parent();

                   var index = $curItem.index();

                   $topPrd = $(this).closest(".row").prev().find(".Prd:eq(" + index + ")");
                   $bottomPrd = $(this).closest(".row").next().find(".Prd:eq(" + index + ")");

                   if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

                       $(this).find(".img1").hide();

                       if ($(this).find(".img2").attr("data-src") != undefined && ($(this).find(".img2").attr("src") == undefined || $(this).find(".img2").attr("src").indexOf("404") != -1)) {
                           $(this).find(".img2").attr("src", $(this).find(".img2").attr("data-src"));
                       }

                       $(this).find(".img2").show();

                   }

                   if ($nextPrd.length > 0) {

                       if ($nextPrd.find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $nextPrd.find(".img2").attr("src") != "/images/src2.gif" && $nextPrd.find(".img2").attr("src") != "") {

                           if ($nextPrd.find(".img2").attr("data-src") != undefined && ($nextPrd.find(".img2").attr("src") == undefined || $nextPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $nextPrd.find(".img2").attr("src", $nextPrd.find(".img2").attr("data-src"));
                           }


                       }
                   }

                   if ($prevPrd.length > 0) {

                       if ($prevPrd.find(".img2").length > 0 && $prevPrd.find(".img2").attr("src") != "/images/src2.gif" && $prevPrd.find(".img2").attr("src") != "") {

                           if ($prevPrd.find(".img2").attr("data-src") != undefined && ($prevPrd.find(".img2").attr("src") == undefined || $prevPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $prevPrd.find(".img2").attr("src", $prevPrd.find(".img2").attr("data-src"));
                           }

                       }

                   }

                   if ($topPrd.length > 0) {

                       if ($topPrd.find(".img2").length > 0 && $topPrd.find(".img2").attr("src") != "/images/src2.gif" && $topPrd.find(".img2").attr("src") != "") {

                           if ($topPrd.find(".img2").attr("data-src") != undefined && ($topPrd.find(".img2").attr("src") == undefined || $topPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $topPrd.find(".img2").attr("src", $topPrd.find(".img2").attr("data-src"));
                           }


                       }
                   }

                   if ($bottomPrd.length > 0) {

                       if ($bottomPrd.find(".img2").length > 0 && $bottomPrd.find(".img2").attr("src") != "/images/src2.gif" && $bottomPrd.find(".img2").attr("src") != "") {

                           if ($bottomPrd.find(".img2").attr("data-src") != undefined && ($bottomPrd.find(".img2").attr("src") == undefined || $bottomPrd.find(".img2").attr("src").indexOf("404") != -1)) {
                               $bottomPrd.find(".img2").attr("src", $bottomPrd.find(".img2").attr("data-src"));
                           }

                       }

                   }

               },
            mouseleave:
               function () {

                   if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

                       $(this).find(".img2").hide();
                       $(this).find(".img1").show();
                   }

               }
        });

    }

    $(document).on("click", '.ProductList .Prd', function (e) {

        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });

    });

    $(document).on("click", '.ProductListColorContainer div.ProductListColor', function () {

        var $currentColor = $(this);

        $(".AjaxLoader").show();

        var productID = $(this).closest(".Prd").find("a:first").attr("data-product");
        var colorID = $(this).attr("data-color");

        var params = "ColorID=" + colorID + "&ProductID=" + productID;

        var parentURL = $(this).closest(".Prd").find(".productImageWrapper > a").attr("href");
        var saltURL = "";
        console.warn(parentURL);
        $detailLinks = $(this).closest(".Prd").find(".productImageWrapper > a");

        var regex = /(\d+)$/;

        if (parentURL.indexOf("#") > 0) {

            saltURL = parentURL.split("#")[0];
            $detailLinks.attr("href", parentURL.split("#")[0] + "#C=" + $(this).attr("data-color"));


        }

        if (regex.test(parentURL) == true) {

            var splittedUrl = parentURL.split("/");

            var curURL = "";
            for (var i = 0; i < splittedUrl.length - 2; i++) {

                if (splittedUrl[i] != "") {
                    curURL += "/" + splittedUrl[i];
                }
            }

            saltURL = curURL;
        }

        $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");

        $currentColor.addClass("active");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetImageOfColors",
            data: params,
            cache: false,
            async: false,
            success: function (data) {

                $(".AjaxLoader").hide();

                $currentColor.closest(".Prd").find("a:first img").remove();

                $curHeight = $currentColor.closest(".Prd").find("a:first img").height();

                for (var i = 0; i < 2; i++) {

                    var $imgKucuk = $('<img >');
                    $imgKucuk.attr('src', (data[i].ImgPath + "?width=400&height=577"));
                    $imgKucuk.height($curHeight);

                    $imgKucuk.addClass("img" + (i + 1) + " PImage");

                    if (i >= 1) {

                        $imgKucuk.addClass("gizli");
                    }

                    $imgKucuk.prependTo($currentColor.closest(".Prd").find("a:first"));

                    if (i == 0 && $(".HomeProducts").length > 0) {

                        $currentColor.closest(".Prd").find("a:first").css("background-image", "url(" + $imgKucuk.attr("src") + ")");
                    }


                    if (i == 0 && data[i].ProductUrl != undefined && data[i].ColorUrl != undefined) {
                        var urlNew = "/" + data[i].ColorName + "-" + data[i].ProductUrl + data[i].ColorUrl;
                        $detailLinks.attr("href", urlNew.replace(saltURL, ""));
                    }

                    $currentColor.closest(".Prd").find("a:first .img2").remove();

                    if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                        var swparams = GetSwPageParams();

                        swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "UrunRenkDegistirme");

                        swparams = ChangeSwHashedStringParamValue(swparams, "ProductID", productID);
                        swparams = ChangeSwHashedStringParamValue(swparams, "ColorID", colorID);

                        AddSwAction(swparams);

                    }

                }

            },
            error: function () {

                console.error('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });



    });

    if ($(".ContentPgArea").length > 0 && isMobile(true)) {
        $('html, body').animate({ scrollTop: $(".ContentPgArea").offset().top }, 'slow');
    }


    $("form.ForgettenForm").live("submit", function () {

        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);

                    $("#email").hide();
                    $("#forgottenPassSubmit").hide();
                    setInterval(closeForgottenPass, 3000);

                    $(".ForgettenForm p:first").removeClass("alert-error");
                    $(".ForgettenForm p:first").addClass("alert alert-success");

                }
                else {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);
                    $(".ForgettenForm p:first").addClass("alert alert-error");
                }



            },
            error: function () {

                console.error('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.UyeOl").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();
        $(".Header1, .Header2").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");


                if (dt.Sonuc == true) {

                    if (dt.JsonRs == "Redirect") {
                        if (dt.Deger5.length > 0) {
                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();


                    $form.hide();

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }
                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                console.error('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });


    var utm_source = getQuery(window.location.href).utm_source;
    var utm_campaign = getQuery(window.location.href).utm_campaign;
    var utm_medium = getQuery(window.location.href).utm_medium;

    if ((utm_source != undefined && utm_source.length > 0) || (utm_campaign != undefined && utm_campaign.length > 0) || (utm_medium != undefined && utm_medium.length > 0)) {

        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/User/SetUtmParam",
            data: "utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium,
            type: "POST",
            cache: false
        });

    }


    $("#SwitchNewLayout").live("click", function () {

        changeSiteTheme($(this).attr("data-ly"));

    });

    $(".BasketContainer .SepetRow").live("swiperight", function () {

        $(this).find(".RemoveIcon").trigger("click");

    });

    $(".BasketContainer .SepetRow").live("swipeleft", function () {

        $(this).find(".RemoveIcon").trigger("click");

    });

    $("#SingOut").live("click", function (e) {

        if (UseTagManager) {
            AddUserAction("Signout");
        }

    });




    if (1 == 2 && $("#homebannerFull1").length > 0 && !isMobile(true)) {
        $(document).snowfall('clear');
        $(document).snowfall({ shadow: true, round: true, minSize: 1, maxSize: 5, flakeCount: 200 }); 

    }


    if ($(window).width() > 1000) {


        $("#LoginRegisterModal .Login").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

        $("#LoginRegisterModal .Register").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

    }

});